import toast from 'react-hot-toast';

export function sendSuccessToast(message) {
  toast.success(message);
}

export function sendErrorToast(message) {
  toast.error(message);
}
